import { useQuery } from "@apollo/client";

import { GqlProtocolGetAllParams } from "~/__generated__";
import useCacheFilterOptions from "~/modules/app/hooks/useCacheFilterOptions";

import { ProtocolListRoute_GetAllDocument } from "../queries.generated";

export const PROTOCOL_GET_ALL = ProtocolListRoute_GetAllDocument;

export default function useProtocolListRoute_GetAll(params: GqlProtocolGetAllParams) {
    const { data, loading, error } = useQuery(PROTOCOL_GET_ALL, {
        variables: { params: { ...params } },
    });

    const queryInfo = data?.protocolGetAll?.queryInfo;
    const [, total] = useCacheFilterOptions(null, queryInfo?.paginationOption.total);

    return {
        loading,
        error,
        total: total,
        data: data?.protocolGetAll?.data,
    };
}
